export default function imageClientHandler(baseImageUrl, api, width, height) {
  width = width || 0
  height = height || 0

  return api ?
    api.image().imageUrl(baseImageUrl, width, height, window.devicePixelRatio) :
    baseImageUrl
}